/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GdsIssSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const gdsIssSync01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsIssSync01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const gdsIssSync01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const gdsIssSync01ExportLoading = (state, { boolean }) => ({
  ...state,
  exportIsLoading: boolean
});

export const gdsIssSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const gdsIssSync01FetchGdsIssSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const gdsIssSync01FetchGdsIssSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const gdsIssSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const gdsIssSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const gdsIssSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const gdsIssSync01ExportSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GdsIssSync01Types.GDS_ISS_SYNC01_SHOW_SYNC_SETTING_LOADING]: gdsIssSync01ShowSyncSettingLoading,
  [GdsIssSync01Types.GDS_ISS_SYNC01_SHOW_SYNC_SETTING_SUCCESS]: gdsIssSync01ShowSyncSettingSuccess,
  [GdsIssSync01Types.GDS_ISS_SYNC01_SHOW_BATCH_JOB_STATUS_SUCCESS]: gdsIssSync01ShowBatchJobStatusSuccess,

  [GdsIssSync01Types.GDS_ISS_SYNC01_RESET_TIMESTAMP]: gdsIssSync01ResetTimestamp,
  [GdsIssSync01Types.GDS_ISS_SYNC01_FETCH_GDS_ISS_SYNC01_LOADING]: gdsIssSync01FetchGdsIssSync01Loading,
  [GdsIssSync01Types.GDS_ISS_SYNC01_FETCH_GDS_ISS_SYNC01_SUCCESS]: gdsIssSync01FetchGdsIssSync01Success,
  [GdsIssSync01Types.GDS_ISS_SYNC01_ADD_SELECTED_DOCUMENTS]: gdsIssSync01AddSelectedDocuments,
  [GdsIssSync01Types.GDS_ISS_SYNC01_REMOVE_SELECTED_DOCUMENTS]: gdsIssSync01RemoveSelectedDocuments,
  [GdsIssSync01Types.GDS_ISS_SYNC01_SET_WORKSPACE_VISIBLE]: gdsIssSync01SetWorkspaceVisible,
  [GdsIssSync01Types.GDS_ISS_SYNC01_EXPORT_LOADING]: gdsIssSync01ExportLoading,
  [GdsIssSync01Types.GDS_ISS_SYNC01_EXPORT_SUCCESS]: gdsIssSync01ExportSuccess
});
